import React, { FC } from 'react'
import { matchPath, Redirect, useHistory } from 'react-router'

// Constants
import { routes } from 'constants/routes'

// Types
interface WorkspaceAgnosticRedirectRouteProps {
  workspaceId: string
  fallbackRoute: string
}

type NonAgnosticRoutes =
  | typeof routes.WORKSPACE_SETTINGS_GENERAL
  | typeof routes.WORKSPACE_SETTINGS_BILLING
  | typeof routes.WORKSPACE_SETTINGS_SSO

// Helpers
/**
 * Map workspace agnostic routes to workspace routes
 */
const getWorkspaceRoute = (path: string): NonAgnosticRoutes => {
  const routeMap = {
    [routes.WORKSPACE_AGNOSTIC_SETTINGS.template()]: routes.WORKSPACE_SETTINGS,
    [routes.WORKSPACE_AGNOSTIC_SETTINGS_GENERAL.template()]: routes.WORKSPACE_SETTINGS_GENERAL,
    [routes.WORKSPACE_AGNOSTIC_SETTINGS_BILLING.template()]: routes.WORKSPACE_SETTINGS_BILLING,
    [routes.WORKSPACE_AGNOSTIC_SETTINGS_SSO.template()]: routes.WORKSPACE_SETTINGS_SSO,
  }

  return routeMap[path]
}

/**
 * Redirects users trying to access workspace routes without a workspace id.
 */
const WorkspaceAgnosticRedirectRoute: FC<WorkspaceAgnosticRedirectRouteProps> = ({
  workspaceId,
  fallbackRoute,
}) => {
  const history = useHistory()

  const isAgnosticRoute = matchPath(history.location.pathname, [
    routes.WORKSPACE_AGNOSTIC_SETTINGS.template(),
    routes.WORKSPACE_SETTINGS_BILLING.template(),
    routes.WORKSPACE_SETTINGS_SSO.template(),
  ])

  if (isAgnosticRoute) {
    return (
      <Redirect
        from={routes.WORKSPACE_AGNOSTIC_SETTINGS.template()}
        to={getWorkspaceRoute(history.location.pathname).create({
          workspaceId,
        })}
      />
    )
  }

  return <Redirect to={fallbackRoute} />
}

export default WorkspaceAgnosticRedirectRoute
